var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NewTask',{attrs:{"taskType":"compare_doc","docList":['Invoice', 'Packing List', 'Waybill']}})
}
var staticRenderFns = []

export { render, staticRenderFns }